import * as React from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import { Typography } from '@mui/material';





export const AlertDialog = ({ open, title, message, onOkey, onCancel }) => {

    return (
        <Dialog
            open={open}
            onClose={() => { onCancel() }}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
        >
            <DialogTitle id="alert-dialog-title">
                <Typography variant='subtitle'>{title?.current}</Typography>
            </DialogTitle>
            <DialogContent>
                <DialogContentText id="alert-dialog-description">
                    <Typography variant='body'>{message?.current}</Typography>
                </DialogContentText>
            </DialogContent>
            <DialogActions>
                <Button onClick={() => { onOkey() }} >
                    Yes
                </Button>
                <Button onClick={() => { onCancel() }}>Cancel</Button>
            </DialogActions>
        </Dialog>
    );
}